import apiService from '../utils/apiService';

import {
  GET_SUBMISSION_DATA_SIGNET_LOOK,
  GET_SUBMISSION_DATA_SIGNET_LOOK_START,
  GET_SUBMISSION_DATA_SIGNET_LOOK_ERROR,
  GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW,
  GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_START,
  GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_ERROR,
  CLEAR_LOOK_CONTETNT,
} from './types';

import {
  submissionDataSignetLookFindBySubmissionDataSignetPath,
  submissionDataSignetLookFindByNamePath,
} from '../constants/apiEndpoints';

const clearLookContent = () => {
  return {
    type: CLEAR_LOOK_CONTETNT,
  };
};

const getSubmissionDataSignetLookStart = () => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_LOOK_START,
  };
};

const getSubmissionDataSignetLookSuccessfully = (data) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_LOOK,
    payload: data,
  };
};

const getSubmissionDataSignetLookUnsuccessfully = (err) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_LOOK_ERROR,
    payload: err,
  };
};

const getSubmissionDataSignetLookContentForPreviewStart = () => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_START,
  };
};

const getSubmissionDataSignetLookContentForPreviewSuccessfully = (data) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW,
    payload: data,
  };
};

const getSubmissionDataSignetLookContentForPreviewUnsuccessfully = (err) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_LOOK_CONTENT_FOR_PREVIEW_ERROR,
    payload: err,
  };
};

export const findSubmissionDataSignetLookLatestVersione = (
  submissionDataSignetId
) => {
  return (dispatch) => {
    dispatch(getSubmissionDataSignetLookStart());
    return apiService
      .get(
        submissionDataSignetLookFindBySubmissionDataSignetPath(
          submissionDataSignetId
        )
      )
      .then((response) => {
        dispatch(getSubmissionDataSignetLookSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getSubmissionDataSignetLookUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findSubmissionDataSignetLookByName = (
  name,
  controllerReference
) => {
  return (dispatch) => {
    dispatch(getSubmissionDataSignetLookContentForPreviewStart());
    return apiService
      .get(submissionDataSignetLookFindByNamePath(name, controllerReference))
      .then((response) => {
        dispatch(
          getSubmissionDataSignetLookContentForPreviewSuccessfully(
            response.data
          )
        );
      })
      .catch((err) => {
        dispatch(
          getSubmissionDataSignetLookContentForPreviewUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const deleteLookContetnt = () => {
  return (dispatch) => {
    dispatch(clearLookContent());
  };
};
